import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ContextService, TokenService } from '@maximizer/core/shared/data-access';
import { isNullOrEmpty } from '@maximizer/shared/util';
import { Observable, catchError, switchMap, throwError } from 'rxjs';
import { ACTIONS_API_URL } from '../tokens';

@Injectable()
export class ActionsAuthInterceptor implements HttpInterceptor {
  private readonly context = inject(ContextService);
  private readonly token = inject(TokenService);
  private readonly apiUrl = inject(ACTIONS_API_URL);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (isNullOrEmpty(this.apiUrl) || !request.url.startsWith(this.apiUrl)) {
      return next.handle(request);
    }

    return next.handle(this.withAuthorization(request)).pipe(
      catchError((error: unknown) => {
        if (
          !(error instanceof HttpErrorResponse) ||
          error.status !== HttpStatusCode.Unauthorized
        ) {
          return throwError(() => error);
        }

        this.context.token = '';
        return this.token.getToken().pipe(
          catchError(() => throwError(() => error)),
          switchMap((token) =>
            isNullOrEmpty(token)
              ? throwError(() => error)
              : next.handle(this.withAuthorization(request)),
          ),
        );
      }),
    );
  }

  private withAuthorization(
    request: HttpRequest<unknown>,
  ): HttpRequest<unknown> {
    return request.clone({
      setHeaders: { Authorization: `Bearer ${this.context.token || ''}` },
    });
  }
}
